<template>
	<div>
		<a-table
			:columns="columns"
			:pagination="pagination"
			@change="handleTableChange"
			:expandedRowKeys="openRows"
			bordered
			:dataSource="data"
			@expandedRowsChange="expandedRowsChange"
			class="components-table-demo-nested"
		>
			<a slot="operation" @click="showDrawer(text.productId)" slot-scope="text">编辑</a>
			<img slot="productPic" style="width: 150px;" slot-scope="text" :src="text.productPic[0]" alt="" />

			<a-tag slot="productSort" slot-scope="text" color="cyan">{{ text.productSort }}</a-tag>
			<span slot="tag" slot-scope="text">
				<div>
					上架：
					<a-switch :defaultChecked="text.putAway" />
				</div>
				<p></p>
				<div>
					推荐：
					<a-switch :defaultChecked="text.recommend" />
				</div>
				<p></p>
				<div>
					包邮：
					<a-switch :defaultChecked="text.postage" />
				</div>
			</span>
			<span slot="onLinePay" slot-scope="text">
				<a-tag v-if="text.onLinePay == 1" color="#87d068">
					<a-badge status="success" />
					开启
				</a-tag>
				<a-tag v-if="text.onLinePay == 0" color="#f50">
					<a-badge status="success" />
					关闭
				</a-tag>
			</span>

			<span slot="auditStatus" slot-scope="text">
				<a-tag v-if="text.auditStatus == 1" color="#87d068">
					<a-badge status="success" />
					已通过
				</a-tag>
				<a-tag v-if="text.auditStatus == 0" color="#f50">
					<a-badge status="success" />
					审核中
				</a-tag>
			</span>

			<a-table slot="expandedRowRender" slot-scope="text" :columns="innerColumns" :dataSource="text.specificationList" :pagination="false">
				<span slot="specificationPic" slot-scope="text"><img style="width: 80px;" :src="text.specificationPic" alt="" /></span>
			</a-table>
		</a-table>

		<a-drawer  :width="1050" title="编辑商品" placement="right" :closable="false" @close="onClose" :visible="visible" :afterVisibleChange="afterVisibleChange">
			<ModifyCommodity :productId="modifyId" ></ModifyCommodity>
		</a-drawer>
	</div>
</template>

<script>
import api from '../../../api/Api.js';
import ModifyCommodity from '../../store/commodity/ModifyCommodity.vue'

const columns = [
	{ title: '商品名称', width: '250px', dataIndex: 'productName', key: 'productName' },
	{ title: '商品图片', width: '200px', key: 'productPic', scopedSlots: { customRender: 'productPic' } },
	{ title: '排序', width: '80px', key: 'productSort', scopedSlots: { customRender: 'productSort' } },
	{ title: '标签', width: '180px', key: 'tag', scopedSlots: { customRender: 'tag' } },
	{ title: '在线支付', key: 'onLinePay', scopedSlots: { customRender: 'onLinePay' } },
	{ title: '添加时间', dataIndex: 'indate', key: 'indate' },
	{ title: '审核状态', key: 'auditStatus', scopedSlots: { customRender: 'auditStatus' } },
	{ title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
];

const innerColumns = [
	{ title: '规格图片', key: 'specificationPic', scopedSlots: { customRender: 'specificationPic' } },
	{ title: '规格', dataIndex: 'specification', key: 'specification' },
	{ title: '库存(件)', dataIndex: 'ku', key: 'ku' },
	{ title: '价格(元)', dataIndex: 'price', key: 'price' }
];

const data = [];

export default {
	components: {
		ModifyCommodity
	},
	data() {
		return {
			page: 0,
			data,
			columns,
			innerColumns,
			index: 0,
			openRows: [],
			pagination: { current: 0, pageSize: 5, total: 55 },
			visible: false,
			modifyId:0
		};
	},
	mounted() {
		this.data = [];
		this.commodityListInfo();
		String.prototype.splice = function(start, newStr) {
			return this.slice(0, start) + newStr + this.slice(start);
		};
	},
	methods: {
		afterVisibleChange(val) {
			console.log('visible', val);
		},
		showDrawer(modifyId) {
			this.modifyId = modifyId;
			this.visible = true;
		},
		onClose() {
			this.visible = false;
		},
		handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			this.pagination = pagination;
			this.page = this.pagination.current - 1;
			this.data = [];
			this.commodityListInfo();
		},
		expandedRowsChange(expandedRows) {
			this.openRows.shift();
			this.openRows = expandedRows;
		},
		numberToBool(number) {
			if (number == 1) {
				return true;
			} else {
				return false;
			}
		},
		commodityListInfo() {
			const that = this;
			let url = 'api/store/v1/admin/commodity/commodityList';
			let parm = {
				page: that.page
			};

			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					console.log(res.data);
					const commodityList = res.data.data;
					that.pagination.total = res.data.maxCount;
					commodityList.forEach((item, index, array) => {
						item.key = index;
						item.putAway = that.numberToBool(item.putAway);
						item.recommend = that.numberToBool(item.recommend);
						item.postage = that.numberToBool(item.postage);

						that.data.push(array[index]);
						array[index].specificationList.forEach((item, index, array) => {
							item.key = index;
							item.price = item.price + '';
							var arr = item.price.split('');
							var price = '';
							for (var i = 0; i < arr.length; i++) {
								price += arr[i];
								if (i == arr.length - 3) {
									price += '.';
								}
							}
							item.price = price;
						});
					});
				} else {
					this.$message.error(res.message);
				}
			});
		}
	}
};
</script>

<style>
.banner-title {
	border-bottom: 2px solid gray;
	margin-bottom: 30px;
	margin-top: 10px;
}
</style>
